import { render } from "./IntroductionBody.vue?vue&type=template&id=4d7cd663"
import script from "./IntroductionBody.vue?vue&type=script&lang=js"
export * from "./IntroductionBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/layout/IntroductionBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d7cd663"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d7cd663', __exports__)) {
    api.reload('4d7cd663', __exports__)
  }
  
  module.hot.accept("./IntroductionBody.vue?vue&type=template&id=4d7cd663", () => {
    api.rerender('4d7cd663', render)
  })

}


export default __exports__